import { projectTypeName } from '../../../common/constants'
import { CsvColumn } from '../reportCsvExport'
import { VisitNotesReportData } from './visitNotesReportApi'

// The same columns and formatting as the Visit Notes table.
export const visitNotesExportColumns: CsvColumn<VisitNotesReportData>[] = [
  {
    title: 'Date',
    dataIndex: 'dateUtc',
    render: (date) => new Date(date).toLocaleDateString()
  },
  {
    title: 'Project Name',
    dataIndex: 'name',
  },
  {
    title: 'Job Type',
    dataIndex: 'jobType',
    render: (_, record) => projectTypeName(record.jobType)
  },
  {
    title: 'Customer',
    dataIndex: 'customerDisplayName',
  },
  {
    title: 'User',
    dataIndex: 'userDisplayName',
  },
  {
    title: 'Client Notes',
    dataIndex: 'clientNotes',
  },
  {
    title: 'Internal Notes',
    dataIndex: 'internalNotes',
  }
]
